import { openLeoOperatorAssistantGuide, leoOperatorAssistantBus } from '@/utils/leoOperatorAssistant'
import { queuePendingSmartGuidePlaybook } from '@/utils/startCommerceOpsUnifyPipeline'

export var BRAND_ORDER_TOGO_PLAYBOOK = 'brand_ops_device_order_lifecycle_r2'

/** 打开 SOC 助手，从品牌主鏈卡住的那步开口填同一张单。 */
export function startBrandOrderTogoVoice (entryStepId) {
  startProcessNetTogoVoice(BRAND_ORDER_TOGO_PLAYBOOK, entryStepId || 'dol_brand_open_orders')
}

export function startProcessNetTogoVoice (playbookId, entryStepId) {
  var payload = {
    playbookId: playbookId || BRAND_ORDER_TOGO_PLAYBOOK,
    entryStepId: entryStepId || ''
  }
  queuePendingSmartGuidePlaybook(payload)
  openLeoOperatorAssistantGuide()
  leoOperatorAssistantBus.$emit('start-smart-guide-playbook', payload)
}



// WEBPACK FOOTER //
// ./src/utils/startBrandOrderTogoPipeline.js